export default "__VITE_ASSET___GFTWiwR__"